module.exports = __webpack_public_path__ + "img/a74c523d7f5d48ba80663c065cdbec80.1226495e.jpg";